export default __webpack_public_path__ + "e1095cb24258556571471999f45c44f6.svg";